import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function TraspasosSalidaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_TRASPASOS_SALIDA = process.env.REACT_APP_URL_TRASPASOS_SALIDA;
  const URL_ARTICULOS_TS = process.env.REACT_APP_URL_ARTICULOS_TS;
  const URL_TRASPASOS_ENTRADA = process.env.REACT_APP_URL_TRASPASOS_ENTRADA;
  const URL_ARTICULOS_TE = process.env.REACT_APP_URL_ARTICULOS_TE;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CAMARONES = process.env.REACT_APP_AREAS_CAMARONES;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  // const URL_TRASPASOS_SOLICITUD = process.env.REACT_APP_URL_TRASPASOS_SOLICITUD;
  // const URL_ARTICULOS_TSOL = process.env.REACT_APP_URL_ARTICULOS_TSOL;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [inventarios, setInventarios] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [areaSalida, setAreaSalida] = useState("");
  const [areaDestino, setAreaDestino] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [totalGeneral, setTotalGeneral] = useState(0);

  const [disponible, setDisponible] = useState([]);

  // Escaneo continuo: un solo input donde se disparan varios QR seguidos.
  const scanRef = useRef(null);
  const [scanQR, setScanQR] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      cantInv: 0,
      idInv: "",
      cajas: 0,
      piezasPorCaja: 0,
      disponible:0,
      cantSolicitud:0,
      costoUnitario: 0,
      precio:0,
      total: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveTraspasosSalida = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    try {
      // 1. Crear el encabezado de la Salida
      const { data: salida } = await axios.post(
        URL_TRASPASOS_SALIDA,
        {
          fecha,
          areaSalida,
          areaDestino,
          observaciones,
          user: user.id,
          total,
          fotoEvidencia: "No",
          total_general: totalGeneral,
          saldo: totalGeneral,
        },
        { headers }
      );

      // 2. Crear cada ArticulosTS (resta del inventario origen
      //    y suma al inventario destino con upsert; lo hace el controller)
      await Promise.all(
        inputFields.map((a) =>
          axios.post(
            URL_ARTICULOS_TS,
            {
              traspasosSalida: salida._id,
              articulos: a.articulos,
              cantidad: parseFloat(a.cantidad),
              surtido: parseFloat(a.cantidad),
              inventarios: a.idInv,
              areas: areaSalida,
              areaDestino,
              costoUnitario: a.costoUnitario,
              precio: a.precio,
              total: a.total,
            },
            { headers }
          )
        )
      );

      // 3. Crear automáticamente el TraspasoEntrada
      //    (el controller marca recibida:"Si" en la Salida)
      const { data: entrada } = await axios.post(
        URL_TRASPASOS_ENTRADA,
        {
          fecha,
          traspasosSalida: salida._id,
          observaciones,
          user: user.id,
          total,
        },
        { headers }
      );

      // 4. Recuperar los ArticulosTS recién creados para tener sus _id
      const { data: artsTS } = await axios.get(
        `${URL_ARTICULOS_TS}/traspasoSalida/${salida._id}`,
        { headers }
      );

      // 5. Crear los ArticulosTE asociados a la Entrada.
      //    Nota: el GET trae articulos populado como array, hay que extraer el _id
      //    del primer elemento porque el validator del back espera un string.
      await Promise.all(
        artsTS.map((a) =>
          axios.post(
            URL_ARTICULOS_TE,
            {
              articulosTS: a._id,
              traspasosEntrada: entrada._id,
              articulos: Array.isArray(a.articulos)
                ? a.articulos[0]?._id || a.articulos[0]
                : a.articulos?._id || a.articulos,
              cantidad: a.cantidad,
              areas: areaDestino,
              areaDestino,
              costoUnitario: a.costoUnitario,
            },
            { headers }
          )
        )
      );

      // 6. Log
      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Traspaso Salida",
          detalle: `${areaSalida} ${total}`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire("Good job!", "Creado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
      setValidaBoton(true);
    }
  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        cajas: 0,
        piezasPorCaja: 0,
        disponible:0,
        cantSolicitud:0,
        costoUnitario: 0,
        precio:0,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(AREAS_CAMARONES == areaSalida){
          if(i.cantInv >= event.target.value
            //  && i.disponible >= event.target.value
             ){
            i[event.target.name] = event.target.value;
            i.total = event.target.value * i.precio
          }else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "La cantidad excede tu inventario o Disponible!",
              showConfirmButton: false,
            });
            i.cajas = 0;
            i.cantidad = 0;
            i.total = 0
          }
        } else if (i.cantInv >= event.target.value) {
          i[event.target.name] = event.target.value;
          i.total = event.target.value * i.precio
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario o Disponible!",
            showConfirmButton: false,
          });
          i.cajas = 0;
          i.cantidad = 0;
          i.total = 0
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
            i[event.target.name] = event.target.value;
            i.total = event.target.value * i.cantidad
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        let cantTemp = parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);

        if(AREAS_CAMARONES == areaSalida){
          if (i.cantInv >= cantTemp && i.disponible >= cantTemp) {
            i[event.target.name] = event.target.value;
            i.cantidad = parseFloat(i.cajas) * parseFloat(i.piezasPorCaja);
            i.total = (parseFloat(i.cajas) * parseFloat(i.piezasPorCaja))*parseFloat(i.precio);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "La cantidad excede tu inventario o Disponible!",
              showConfirmButton: false,
            });
            i.cajas = 0;
            i.cantidad = 0;
            i.total = 0;
          }
        } else if (i.cantInv >= cantTemp) {
          i[event.target.name] = event.target.value;
          i.cantidad = parseFloat(i.cajas) * parseFloat(i.piezasPorCaja);
          i.total = (parseFloat(i.cajas) * parseFloat(i.piezasPorCaja))*parseFloat(i.precio);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario o Disponible!",
            showConfirmButton: false,
          });
          i.cajas = 0;
          i.cantidad = 0;
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Escaneo continuo: cada QR agrega una fila con cantidad 1 (o suma +1 si el
  // articulo ya esta en la lista). El input se limpia solo y conserva el foco
  // para poder disparar el siguiente codigo sin tocar el mouse.
  function EscaneaContinuo(event) {
    const value = (event.target.value || "").trim();

    if (value.length < 24) {
      setScanQR(value);
      return;
    }

    const found = inventarios.find(
      (a) => String(a.idArticulo) === String(value)
    );

    // Limpiamos y devolvemos el foco para dejar listo el siguiente escaneo.
    setScanQR("");
    if (scanRef.current) scanRef.current.focus();

    if (!found) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo no aparece en tu inventario",
        showConfirmButton: false,
        timer: 1200,
      });
      return;
    }

    const codigo = found.codigo || "";
    const firstChar = (codigo[0] || "X").toUpperCase();
    const optionObj = {
      ...found,
      junta: `${codigo} ${found.nombre || ""}`.trim(),
      firstLetter: /[0-9]/.test(firstChar) ? "0-9" : firstChar,
    };
    const cantInv = parseFloat(found.cantidad) || 0;
    const precio = parseFloat(found.precioTienda) || 0;

    setInputFields((prev) => {
      const idx = prev.findIndex(
        (i) => String(i.articulos) === String(found.idArticulo)
      );

      // Ya existe: sumamos 1 respetando el tope de inventario.
      if (idx !== -1) {
        const actual = parseFloat(prev[idx].cantidad) || 0;
        if (actual + 1 > cantInv) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario!",
            showConfirmButton: false,
            timer: 1200,
          });
          return prev;
        }
        const copia = [...prev];
        copia[idx] = {
          ...copia[idx],
          cantidad: actual + 1,
          total: (actual + 1) * (parseFloat(copia[idx].precio) || 0),
        };
        return copia;
      }

      if (cantInv < 1) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Sin inventario disponible!",
          showConfirmButton: false,
          timer: 1200,
        });
        return prev;
      }

      const nueva = {
        id: uuidv4(),
        codigoQR: value,
        articulos: found.idArticulo,
        articulosNombre: optionObj,
        cantidad: 1,
        cantInv,
        idInv: found._id,
        cajas: 0,
        piezasPorCaja: parseFloat(found.piezasPorCaja) || 0,
        disponible: 0,
        cantSolicitud: 0,
        costoUnitario: parseFloat(found.costoUnitario) || 0,
        precio,
        total: precio,
      };

      // Si la unica fila esta vacia la reemplazamos, si no agregamos al final.
      if (prev.length === 1 && !prev[0].articulos) return [nueva];
      return [...prev, nueva];
    });
  }

  function BuscaQR(id, event) {
    // trim() por si el scanner o copy/paste meten espacios o saltos de linea.
    const value = (event.target.value || "").trim();

    // Mientras se teclea/escanea, guarda el valor crudo en la fila.
    if (value.length < 24) {
      setInputFields((prev) =>
        prev.map((i) => (i.id === id ? { ...i, codigoQR: value } : i))
      );
      return;
    }

    // Comparamos como string para evitar problemas si idArticulo es ObjectId.
    const found = inventarios.find(
      (a) => String(a.idArticulo) === String(value)
    );

    if (!found) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo no aparece en tu inventario",
        showConfirmButton: false,
      });
      setInputFields((prev) =>
        prev.map((i) => (i.id === id ? { ...i, codigoQR: "" } : i))
      );
      return;
    }

    // Construye el objeto opcion para que el Autocomplete lo muestre.
    const codigo = found.codigo || "";
    const firstChar = (codigo[0] || "X").toUpperCase();
    const optionObj = {
      ...found,
      junta: `${codigo} ${found.nombre || ""}`.trim(),
      firstLetter: /[0-9]/.test(firstChar) ? "0-9" : firstChar,
    };

    // Encontrado: precarga todos los datos del articulo en la fila.
    // Mantenemos el ID en codigoQR para que el usuario vea que escaneo.
    setInputFields((prev) =>
      prev.map((i) =>
        i.id === id
          ? {
              ...i,
              codigoQR: value,
              articulos: found.idArticulo,
              articulosNombre: optionObj,
              cantInv: parseFloat(found.cantidad) || 0,
              idInv: found._id,
              piezasPorCaja: parseFloat(found.piezasPorCaja) || 0,
              costoUnitario: parseFloat(found.costoUnitario) || 0,
              precio: parseFloat(found.precioTienda) || 0,
            }
          : i
      )
    );
  }

  function BuscaArticulo(id, selectedArticulo) {
    if (
      inventarios.filter((e) => e.idArticulo == selectedArticulo.idArticulo).length == 1
    ) {
      inventarios.map((a) => {
        if (a.idArticulo == selectedArticulo.idArticulo) {
          let idArticulo = a.idArticulo;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          let costoUnitario = a.costoUnitario
          let precio = a.precioTienda
          handleChangeInputArticuloUnico(
            id,
            idArticulo,
            piezasPorCaja,
            cantInv,
            idInv,
            costoUnitario,
            precio
          );
        }
      });

      disponible.map((a) => {
        if (a.idArticulo == selectedArticulo.idArticulo) {
          let disponible = a.disponible;
          handleChangeInputDispobinle(id, disponible);
        }
      });

    } else {
      inventarios.map((a) => {
        if (a.idArticulo == selectedArticulo.idArticulo) {
          let idArticulo = a.idArticulo;
          // let cantInv = parseFloat(a.cantidad)
          // let idInv = a._id
          let piezasPorCaja = a.piezasPorCaja;
          let costoUnitario = a.costoUnitario;
          let precio = a.precioTienda
          handleChangeInputArticulo(id, idArticulo, piezasPorCaja, costoUnitario, precio);
        }
      });

      disponible.map((a) => {
        if (a.idArticulo == selectedArticulo.idArticulo) {
          let disponible = a.disponible;
          handleChangeInputDispobinle(id, disponible);
        }
      });
    }
  }
  const handleChangeInputArticuloUnico = (
    id,
    idArticulo,
    piezasPorCaja,
    cantInv,
    idInv,
    costoUnitario,
    precio
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = parseFloat(cantInv);
        i.idInv = idInv;
        i.piezasPorCaja = parseFloat(piezasPorCaja);
        i.costoUnitario = parseFloat(costoUnitario)
        i.precio = parseFloat(precio)
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, costoUnitario, precio) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = 0
        i.idInv = ""
        i.piezasPorCaja = parseFloat(piezasPorCaja);
        i.costoUnitario = parseFloat(costoUnitario)
        i.precio = parseFloat(precio)
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputDispobinle = (id, disponible) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.disponible = parseFloat(disponible);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };


  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);

    let din = inputFields.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TD);
  }

  // Recalcula totales cada vez que cambian las filas. Necesario para el
  // escaneo continuo, donde setInputFields usa la forma callback y
  // ActualizaTotales leeria el estado anterior.
  useEffect(() => {
    const TC = inputFields.reduce(
      (t, c) => t + (parseFloat(c.cantidad) || 0),
      0
    );
    const TD = inputFields.reduce((t, c) => t + (parseFloat(c.total) || 0), 0);
    setTotal(TC);
    setTotalGeneral(TD);
  }, [inputFields]);

  function jalaAlmacenSalida(e) {
    setAreaSalida(e);
    toggleProgreso()

      axios
        .get(`${URL_INVENTARIOS}/traspasos/${e}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allInventarios = res.data;
          setInventarios(allInventarios);

          let result = allInventarios.map((a) => a.idArticulo);
          setIdsArticulos(result);

          let unicos = allInventarios.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.idArticulo === value.idArticulo)
          );
          setArticulosUnicos(unicos);
        })
        .catch((err) => {
          console.log(err);
        });

        // axios
        // .get(`${URL_INVENTARIOS}DisponibleTraspaso/${e}`, {
        //   headers: {
        //     Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        //   },
        // })
        // .then((response) => {
        //   let allDisponible = response.data;
        //   setDisponible(allDisponible);
        // })
        // .catch((err) => {
        //   console.log(err);
        // });
    
        setTimeout(()=>{
          setModalProgreso(false)
        }, 3000)

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        cajas: 0,
        piezasPorCaja: 0,
        disponible:0,
        cantSolicitud:0,
        costoUnitario: 0,
        precio:0,
        total: 0,
      },
    ]);
  }


  const options = articulosUnicos.map((option) => {
    const junta = option.codigo + option.nombre;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.traspasos_salida_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Traspaso</h3>
          <Form onSubmit={saveTraspasosSalida}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Salida</Label>
                {user.areas == AREAS_GENERAL ? (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id != AREAS_GENERAL) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                ) : (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .filter((a) => a.is_active === "Si")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas == a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                )}
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Destino</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={areaDestino}
                  required
                  onChange={(e) => {
                    setAreaDestino(e.target.value);
                  }}
                >
                  <option value="0">Almacen Destino</option>
                  {areas
                    .filter((a) => a.is_active === "Si")
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a._id != AREAS_GENERAL) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>

              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              </Row>
              <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            <br />

            {/* Escaneo continuo: dispara varios QR seguidos sin mover el cursor */}
            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Escaneo Continuo (QR)</Label>
                <Input
                  innerRef={scanRef}
                  autoFocus
                  type="text"
                  placeholder="Escanea aqui varios codigos seguidos"
                  value={scanQR}
                  onChange={(e) => EscaneaContinuo(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                  }}
                  disabled={!areaSalida || areaSalida == "0"}
                />
              </Col>
              <Col md={8}>
                <Label className="mr-sm-2">&nbsp;</Label>
                <p style={{ color: "#666", marginTop: 8 }}>
                  Cada escaneo agrega el articulo con cantidad 1. Si ya esta en
                  la lista, le suma 1 mas.
                </p>
              </Col>
            </Row>
            <br />

            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Codigo QR</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Modelo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>

              <Col md={1}>
                <Label className="mr-sm-2">Inventario</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="codigoQR"
                      type="text"
                      placeholder="QR / ID"
                      value={inputField.codigoQR || ""}
                      onChange={(event) => BuscaQR(inputField.id, event)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                      disabled={!areaSalida || areaSalida == "0"}
                    />
                  </Col>
                  <Col md={3}>
                    <Autocomplete
                                        size="small"
                                        value={inputField.articulosNombre}
                                        onChange={(event, selectedArticulo) => {
                                          BuscaArticulo(inputField.id, selectedArticulo);
                                        }}
                                        options={options.sort(
                                          (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                                        )}
                                        groupBy={(option) => option.firstLetter}
                                        getOptionLabel={(option) => option.junta}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Selecciona"
                                            variant="outlined"
                                          />
                                        )}
                                        renderOption={(option) => (
                                          <React.Fragment>
                                            {option.codigo} {option.nombre}
                                          </React.Fragment>
                                        )}
                                      />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articuloNombre"
                      type="text"
                      value={(() => {
                        if (!inputField.articulos) return "";
                        const inv = inventarios.find(
                          (a) =>
                            String(a.idArticulo) === String(inputField.articulos)
                        );
                        return inv
                          ? `${inv.codigo || ""} ${inv.nombre || ""}`.trim()
                          : "";
                      })()}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantInv"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantInv}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoTraspasosSalida"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default TraspasosSalidaCreate;
